// components/ThemeToggle.tsx — 3-state theme control: System / Dark / Light (spec §4.5).
import { themeLabel } from '../lib/theme';
import { useTheme } from '../hooks/useTheme';

const ICON: Record<string, string> = { system: '◐', dark: '●', light: '○' };

export function ThemeToggle() {
  const { theme, cycle } = useTheme();
  return (
    <button
      type="button"
      onClick={cycle}
      className="theme-toggle"
      aria-label={`Theme: ${themeLabel(theme)}. Click to change.`}
      title={`Theme: ${themeLabel(theme)}`}
      data-theme={theme}
    >
      <span aria-hidden="true">{ICON[theme]}</span>
      <span className="theme-toggle__label">{themeLabel(theme)}</span>
    </button>
  );
}
